export default "__VITE_ASSET__BEQqLnur__"